var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardAbandonedCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33333 20.1667C7.83959 20.1667 8.25 19.7563 8.25 19.25C8.25 18.7437 7.83959 18.3333 7.33333 18.3333C6.82707 18.3333 6.41667 18.7437 6.41667 19.25C6.41667 19.7563 6.82707 20.1667 7.33333 20.1667Z",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4167 20.1667C17.9229 20.1667 18.3333 19.7563 18.3333 19.25C18.3333 18.7437 17.9229 18.3333 17.4167 18.3333C16.9104 18.3333 16.5 18.7437 16.5 19.25C16.5 19.7563 16.9104 20.1667 17.4167 20.1667Z",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.87917 1.87917H3.7125L6.15083 13.2642C6.24028 13.6811 6.47228 14.0539 6.8069 14.3182C7.14152 14.5826 7.55783 14.722 7.98417 14.7125H16.9492C17.3664 14.7118 17.7709 14.5688 18.0959 14.3072C18.4209 14.0455 18.647 13.6808 18.7367 13.2733L20.2492 6.4625H4.69333",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAbandonedCart);
export default __webpack_public_path__ + "static/media/card-abandoned-cart.f6fa323d3f6a14f198e8f7ed6753a338.svg";
export { ForwardRef as ReactComponent };